import { Component, OnInit, Input } from '@angular/core';
import { Detalhamento } from '../detalhamento';
import {ProdutosService} from '../../../home/home/conteudo/produtos/produtos.service';

@Component({
  selector: 'store-similares',
  templateUrl: './similares.component.html',
  styleUrls: ['./similares.component.scss']
})
export class SimilaresComponent implements OnInit {

  @Input()
  public detalhamento: Detalhamento;

  public produtos: any[] = [];

  constructor(private produtosService: ProdutosService) { }

  getSlug(produto) {
    return produto.slug || produto.id;
  }

  ngOnInit() {

    const plataforma = ['extensao'];
    const area = [this.detalhamento.areaNegocio.identificador];
    const nome = this.detalhamento.nome

    const filtros = new Map();
    filtros.set('plataformas', plataforma);
    filtros.set('areasNegocio', area);

    this.produtosService.getProdutos(filtros, [], 0, 999)
        .subscribe(produtos => {
            this.produtos = produtos.content;
            this.filterProd(nome);
        });

  }

  filterProd(prod){
    this.produtos = this.produtos.filter(p => p.highlights.some( h => h.titulo === prod))
  }

}
